<template>
  <div
    class="landingBusinessBenefitsTiles"
    :class="[
      {
        'landingBusinessBenefitsTiles--gray': data.IsGrayBg,
        'landingBusinessBenefitsTiles--itemsSpace': data.IsItemsSpace || !data.IsGrayBg,
      },
    ]"
  >
    <div class="container">
      <div v-if="data.SmallTitle" class="landingBusinessBenefitsTiles__smallTitle">
        {{ data.SmallTitle }}
      </div>
      <h2 v-if="data.Title" class="landingBusinessBenefitsTiles__title">
        {{ data.Title }}
      </h2>
      <div class="landingBusinessBenefitsTiles__swiperWrapper">
        <div v-if="data.IsHorizontalIcon" class="landingBusinessBenefitsTiles__boxes">
          <IconBoxes :items="iconBoxesItems" />
        </div>
        <SwiperSlider
          v-else-if="data.Tiles"
          ref="swiper"
          class="landingBusinessBenefitsTiles__swiper"
          :options="swiperOptions"
        >
          <div
            v-for="(tile, index) in data.Tiles"
            :key="index"
            class="landingBusinessBenefitsTiles__slide swiper-slide"
          >
            <component
              :is="tile.Url ? 'a' : 'div'"
              :href="tile.Url"
              class="landingBusinessBenefitsTiles__slideWrapper"
            >
              <div class="landingBusinessBenefitsTiles__slideContent">
                <img
                  v-if="tile.Icon"
                  :src="JSON.parse(tile.Icon).url"
                  alt=""
                  :class="[
                    'landingBusinessBenefitsTiles__slideIcon',
                    {
                      'landingBusinessBenefitsTiles__slideIcon--icon': tile.IsIcon,
                    },
                  ]"
                />
                <h3 v-if="tile.Title" class="landingBusinessBenefitsTiles__slideTitle">
                  {{ tile.Title }}
                </h3>
                <div v-if="tile.Description" class="landingBusinessBenefitsTiles__slideDesc">
                  {{ tile.Description }}
                </div>
              </div>
              <div v-if="tile.Image" class="landingBusinessBenefitsTiles__slideImage">
                <new-image-box
                  :alt="tile.Title ? tile.Title : ''"
                  background-color="#fff"
                  :src="JSON.parse(tile.Image).url"
                  :width="350"
                  :height="165"
                  fit
                  image-params="w_350,h_165,crop"
                />
              </div>
            </component>
          </div>
          <div slot="pagination" class="swiper-pagination" />
        </SwiperSlider>
        <div class="landingLogosWithDescSection__navigation swiper-navigation">
          <SliderButton position="prev" @click="prevEl" :disabled="prevDisable" />
          <SliderButton position="next" @click="nextEl" :disabled="nextDisable" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VButton from '@/components/VButton.vue';
import SwiperSlider from '@/components/SwiperSlider.vue';
import NewImageBox from '@/components/NewImageBox.vue';
import SliderButton from '@/components/Sliders/SliderButton.vue';
import IconBoxes from '@/components/IconBoxes.vue';

export default {
  name: 'LandingBusinessBenefitsTiles',
  components: { IconBoxes, SliderButton, NewImageBox, SwiperSlider, VButton },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      nextDisable: false,
      prevDisable: false,
      swiperOptions: {
        slidesPerView: 'auto',
        loop: false,
        speed: 600,
        spaceBetween: 0,
        watchOverflow: true,
        pagination: {
          el: '.swiper-pagination',
        },
      },
    };
  },
  computed: {
    iconBoxesItems() {
      return this.data.Tiles.map(({ Icon, IconAlt, Url, Title, Description }) => ({
        href: Url,
        alt: IconAlt,
        title: Title,
        desc: this.parseDescription(Description),
        icon: Icon ? JSON.parse(Icon).url : '',
        width: 60,
        height: 38,
      }));
    },
    swiper() {
      if (this.$refs.swiper) {
        return this.$refs.swiper.swiper;
      }
      return false;
    },
  },
  mounted() {
    if (this.swiper) {
      this.swiper.on('slideChange', () => {
        this.checkArrows();
      });

      this.swiper.once('update', () => {
        this.swiper.on('slideChange', () => {
          this.checkArrows();
        });
      });

      this.checkArrows();
    }
  },
  methods: {
    parseDescription(desc) {
      if (desc.includes('$freeShipping')) {
        return desc.replace('$freeShipping', this.businessVariables.freeShipping.grossFormatted);
      }
      return desc;
    },
    refreshSlider() {
      this.swiper.update();
      this.checkArrows();
    },
    checkArrows() {
      this.nextDisable = this.swiper.isEnd;
      this.prevDisable = this.swiper.activeIndex === 0;
    },
    prevEl() {
      if (this.swiper) {
        this.swiper.slidePrev();
      }
    },
    nextEl() {
      if (this.swiper) {
        this.swiper.slideNext();
      }
    },
  },
};
</script>
<style scoped lang="scss">
.landingBusinessBenefitsTiles {
  $root: &;
  padding: 4.6rem 0 1.6rem;
  background: $cWhite;
  overflow: hidden;

  @include rwd('tablet') {
    padding: 3rem 0 0;
  }

  &__smallTitle {
    font-size: 1.8rem;
    line-height: 1.5;
    color: $cAddDark02;
    font-weight: 500;
    margin-bottom: 1rem;
  }

  &__title {
    font-size: 4.8rem;
    line-height: 1.1;
    font-weight: 500;
    max-width: 68rem;
    margin-bottom: 3.8rem;

    @include rwd('large-tablet') {
      font-size: 3.6rem;
      margin-bottom: 2rem;
    }

    @include rwd('tablet') {
      font-size: 2.8rem;
    }
  }

  &__swiperWrapper {
    position: relative;
  }

  &__swiper {
    position: relative;
    margin-top: 4rem;
    padding-bottom: 4rem;

    @include rwd('large-tablet') {
      overflow: visible;
    }

    @include rwd('tablet') {
      margin-top: 2.5rem;
    }
  }

  .swiper-pagination {
    bottom: 0;
  }

  &__slide {
    max-width: 25%;
    background: $cWhite;
    height: auto;

    @include rwd('small-laptop') {
      max-width: 33.333%;
    }

    @include rwd('tablet') {
      max-width: 50%;
    }

    @include rwd('large-phone') {
      max-width: 100%;
    }
  }

  &__slideWrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  &__slideContent {
    border-right: 1px solid $cAddLight;
    padding: 3.2rem 3.2rem 5.4rem 3.2rem;
    flex: 1;
    overflow: hidden;

    @include rwd('tablet') {
      padding: 2.4rem;
    }
  }

  &__slideTitle {
    font-size: 2.4rem;
    line-height: 1.3;
    font-weight: 500;
    margin-top: 1.8rem;

    @include rwd('tablet') {
      font-size: 2rem;
    }
  }

  &__slideDesc {
    font-size: 1.8rem;
    line-height: 1.3;
    color: $cAddDark02;
    margin-top: 1.3rem;

    @include rwd('tablet') {
      font-size: 1.6rem;
    }
  }

  &__slideIcon {
    max-height: 8rem;

    &--icon {
      max-height: 4rem;
    }
  }

  &__slideImage {
    height: 16.5rem;
    border-right: 1px solid $cWhite;
    margin-top: auto;
  }

  &__boxes {
    border: 1px solid $cAddLight;
  }

  &--gray {
    background: $cBg;

    #{$root}__boxes {
      border: none;
    }
  }

  &--itemsSpace {
    #{$root}__swiper {
      margin: 4rem -0.8rem 0;
    }

    #{$root}__slide {
      padding: 0 0.8rem;
    }

    #{$root}__slideContent {
      border-right: none;
    }

    #{$root}__slideWrapper {
      border: 1px solid $cAddLight;
      border-radius: 5px;
      overflow: hidden;
    }
  }
}
</style>
